<template>
  <div id="input">
    <component :is="displayingButton + '_pause'"
      @setnote="setnote" />
    <component :is="displayingButton + '_note'"
      @setnote="setnote" />
    <ul id="switch">
      <li id="bs" @click="backspace()"><div><img src="../../assets/btn/bsL.png" width="40" height="40"></div></li>
      <li id="dot" @click="isDot=!isDot" :class="{active:isDot}"><div>付点<br>(×1.5)</div></li>
      <li id="tie" @click="isTie=!isTie" :class="{active:isTie}"><div><img src="../../assets/btn/tiesw.png" width="40" height="40"></div></li>
      <li id="triplet" @click="changeDisplay()"><mode_switch :current="currentDisplay" /></li>
    </ul>
  </div>
</template>

<script>
import nomal_pause from './input/nomal_pause.vue'
import nomal_note from './input/nomal_note.vue'
import triplet_pause from './input/triplet_pause.vue'
import triplet_note from './input/triplet_note.vue'
import mode_switch from './input/mode_switch.vue'
export default {
  name: 'notes',
  components: {
    mode_switch,
    nomal_pause,
    nomal_note,
    triplet_pause,
    triplet_note,
  },
  props: {
  },
  data: () => {
    return {
      displays: ['nomal', 'triplet'],
      currentDisplay: 0,
      isSetting: false,
      isDot: false,
      isTie: false,
    }
  },
  methods: {
    setnote: function(e){
      if (this.isDot && (e.length === 240 || e.length === 160)) {
        return false;
      }
      let object = {
          length: e.length,
          onoff: e.bool,
          dotted: this.isDot,
          tie: this.isTie,
      }
      this.$store.commit('addnote', {note: object});
      this.isDot = false;
      this.isTie = false;
    },
    backspace: function(){
      this.$store.commit('backspace');
    },
    changeDisplay: function () {
      if (this.currentDisplay === 0) {
        this.currentDisplay = 1;
      } else if (this.currentDisplay === 1) {
        this.currentDisplay = 0;
      }
    }
  },
  computed: {
    displayingButton: function () {
      return this.displays[this.currentDisplay]
    }
  }
}
</script>

<style>
#input{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 264px;
  padding: 4px 0;
}
#input ul{
  position: relative;
  display: flex;
  flex-direction: column;
	padding: 0;
	margin: 0;
  width: 120px;
	list-style: none;
}
#input ul li{
  display: block;
  position: relative;
  margin: 2px;
  padding: 0;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
}
ul#switch li div{
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
#dot.active, #tie.active{
  background-color: #ffd9bc;
}
</style>
